import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CosbotsFormComponent } from './cosbots-form/cosbots-form.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ToastComponent } from './util/toast/toast.component';
import { LoginComponent } from './util/pages/login/login.component';

@NgModule({
  declarations: [AppComponent, CosbotsFormComponent, ToastComponent, LoginComponent],
  imports: [BrowserModule, FormsModule, ReactiveFormsModule, AppRoutingModule, HttpClientModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
